export default function Unauthorized() {
  return (
    <div className="p-10 text-center mt-20">
      <h1 className="text-2xl font-bold text-red-600">
        Acceso no autorizado
      </h1>
      <p className="mt-2 text-gray-600">
        No tiene permisos para acceder a esta cuenta.
      </p>
    </div>
  );
}
